import * as React from 'react';
import * as _ from 'lodash'
import * as moment from 'moment';
import classnames from 'classnames'
import Wrapper from './Wrapper'
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import FileUploadButton from './FileUploadButton';
import { Toggle, Link, TextField } from 'office-ui-fabric-react/lib/index';
import { Dropdown, DropdownMenuItemType, IDropdownStyles, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { apiGetAccount, clientLog } from '../util'

export interface AppProps {
    onFileUpload: (files: FileList, cloneBodyAndSubjectFromCampaignID?: string) => void,
    onDirectDataUpload: (data: any, cloneBodyAndSubjectFromCampaignID?: string) => void,
    onCreateFollowUp: (createSourceFromCampaignID?: string, createSourceFromCriteria?: string) => void,
    account: any,
    onSignout: () => void,
    autoLogin: (any, string) => string,
}

export interface Props extends AppProps {
    firstRun: boolean,
    defaultDirectData?: string,
}

export interface State {
    isTeachingBubbleVisible: boolean;
    followUpToCampaignID: string;
    cloneCampaignID: string;
    followUpToCriteria: string;
    directData: string;
    showDirectData: boolean;
    toEmailAddresses: string[];

}

export default class CampaignStart extends React.Component<Props, State> {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isTeachingBubbleVisible: props.firstRun,
            followUpToCampaignID: null,
            cloneCampaignID: '',
            followUpToCriteria: null,
            directData: props.defaultDirectData,
            showDirectData: props.defaultDirectData != null,
            toEmailAddresses: []
        }
    }

    async componentDidMount() {
        await this.getToAddresses();
        setInterval(async () => await this.getToAddresses(), 1000);

    }

    getToAddresses = async () => {
        Office.context.mailbox.item.to.getAsync({}, this.onGetToAddresses);
    }

    onGetToAddresses = async (result: Office.AsyncResult<Office.EmailAddressDetails[]>) => {
        if (result.status == Office.AsyncResultStatus.Failed) {
            clientLog(`Error in onGetToAddresses: ${result.error}`);
        }
        else {
            const toEmailAddresses = _.sortBy(_.map(
                _.filter(
                    result.value,
                    toEntry => toEntry.emailAddress.toLowerCase().split('@')[1] !== 'campaign.mailmerge365.com'),
                toEntry => toEntry.emailAddress.toLowerCase()));

            if (!_.isEqual(toEmailAddresses, this.state.toEmailAddresses)) {
                this.setState({ toEmailAddresses });
            }
        }
    }

    clearToAddresses = async () => {
        clientLog("Clearing addresses")
        await Office.context.mailbox.item.to.setAsync([], null, async () => { clientLog("Cleared addresses") });
    };

    onDismissTeachingBubble = (event) => {
        this.setState({
            isTeachingBubbleVisible: !this.state.isTeachingBubbleVisible
        });
    }

    render() {
        const {
            account,
            autoLogin,
            onSignout,
        } = this.props;
        const {
            isTeachingBubbleVisible,
            followUpToCampaignID,
            followUpToCriteria,
            directData,
            showDirectData,
            toEmailAddresses
        } = this.state;

        const campaigns = account.campaigns;
        const hasExistingCampaigns = campaigns && campaigns.length > 0;

        const dropdownStyles: Partial<IDropdownStyles> = {
        };

        const options: IDropdownOption[] = campaigns && _.sortBy(
            campaigns.map(c => ({
                key: c.id.toString(),
                text: `${c.name.toString()} (${moment.utc(c.sentOn).format('L')})`
            })),
            x => 'text'
        );

        const canSendFollowUpCampaign = followUpToCampaignID != null && followUpToCampaignID.length > 0 &&
            followUpToCriteria != null && followUpToCriteria.length > 0;

        const cloneOptions = [{
            key: '',
            text: 'Blank campaign'
        }, ...(options||[])];

        return (
            <>
                {isTeachingBubbleVisible ?
                    <div className="mm-intro ms-bgColor-themePrimary">
                        <div className="-header">
                            <p className="ms-font-xxl">Congratulations, you're ready to go</p>
                        </div>
                        <div className="-body">
                            <p className="ms-font-m ms-fontWeight-semilight">We recommend checking out some of our tutorials, but if you can't wait just close this message and upload your first spreadsheet or text file.</p>
                        </div>
                        <div className="-footer">
                            <PrimaryButton onClick={this.onDismissTeachingBubble}>Close</PrimaryButton>
                            <DefaultButton target="_blank" href="https://mm365.me/tutorials">More Information</DefaultButton>
                        </div>
                    </div> : null}
                <Wrapper
                    onSignout={onSignout}
                    account={account}
                    autoLogin={autoLogin}
                    className={classnames("mm-view")}>
                    <p className="ms-font-l" style={{ marginTop: "1rem", fontWeight: 400 }}>Start a new campaign</p>

                    {!showDirectData ?
                        <>
                            {hasExistingCampaigns && <>
                                <div className="mm-para" >
                                    <Dropdown
                                        label={"First, do you want to start with a blank campaign or copy the body and subject from a previous one?"}
                                        options={cloneOptions}
                                        styles={dropdownStyles}
                                        onChange={(e, item) => this.setState({ cloneCampaignID: item.key.toString() })}
                                        selectedKey={this.state.cloneCampaignID}
                                    />
                                </div>
                                <p className="ms-font-m -message">Next, choose the data source to start the campaign.</p>

                            </>
                            }
                            {!hasExistingCampaigns &&
                                <p className="ms-font-m -message">To start setting up your mail merge campaign upload a file containing at least a list of email addresses. You can add up to 50 additional columns to personalize the email.</p>
                            }
                            <div className="mm-para -button flex-column" >
                                <FileUploadButton onFileUpload={(files) => this.props.onFileUpload(files, this.state.cloneCampaignID)} />
                                <DefaultButton
                                    style={{ "fontWeight": 400, "marginTop": ".5rem" }}
                                    onClick={() => this.setState({ showDirectData: true })}>Manually add a list of recipients</DefaultButton>

                                {toEmailAddresses && toEmailAddresses.length > 0 &&
                                    <DefaultButton
                                        style={{ "fontWeight": 400, "marginTop": ".5rem" }}
                                        onClick={() => {
                                            this.clearToAddresses();
                                            this.props.onDirectDataUpload(toEmailAddresses.join('\n'));
                                        }}>Use current list of email recipients</DefaultButton>
                                }
                                <div className="" style={{ marginTop: "1rem" }}>
                                    <ul className="-links">
                                        <li key={'first-campaign'}><i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i>
                                            <Link target="_blank" href="https://mm365.me/first-campaign">Tutorial for new users</Link></li>
                                        <li key={'faq'}><i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i>
                                            <Link target="_blank" href="https://mm365.me/faq-spreadsheet">FAQ about file formats</Link></li>
                                    </ul>

                                </div>
                            </div>
                        </> : <>
                            <p className="ms-font-m -message">Type or paste either a list of email addresses here (no header needed) or comma separated data values (including a header line)</p>
                            <div className="mm-para" >
                                <TextField
                                    multiline
                                    rows={20}
                                    placeholder=""
                                    value={directData}
                                    onPaste={(e) => {
                                        var txt = e.clipboardData.getData('Text');
                                        if (txt.indexOf("\n")<0) {
                                            // single line
                                            var splitIntoEmails = txt.replace(',',';').split(';');
                                            if (splitIntoEmails.length > 0) {
                                                console.log(splitIntoEmails);
                                                this.setState({ directData: splitIntoEmails.join("\n") });
                                                e.preventDefault();
                                            }
                                        }
                                    }}
                                    onChange={(e, newText) => this.setState({ directData: newText })} />
                            </div>
                            <div className="mm-para -button flex-column" >
                                <PrimaryButton
                                    style={{ "fontWeight": 400 }}
                                    onClick={() => this.props.onDirectDataUpload(directData, this.state.cloneCampaignID)}
                                    title="Add email addresses into the text field above to start a campaign based on those recipients"
                                    disabled={!directData || directData.trim().length == 0} >Start campaign</PrimaryButton>
                            </div>
                            <div className="mm-para -button flex-column" >
                                <DefaultButton
                                    style={{ "fontWeight": 400 }}
                                    onClick={() => this.setState({ showDirectData: false })}>Back to file upload</DefaultButton>
                            </div>
                        </>
                    }
                    {!showDirectData && hasExistingCampaigns && this.props.onCreateFollowUp &&
                        <React.Fragment>
                            <hr style={{ border: "none", borderBottom: "1px solid #ddd", "marginTop": "1rem", "marginBottom": "1rem" }} />
                            <p className="ms-font-l" style={{ marginTop: "1rem", fontWeight: 400 }}>Start a follow-up campaign</p>
                            <p className="ms-font-m -message">To start a follow-up campaign, select a previous campaign and which segment of recipients to send to.</p>

                            <div className="mm-para" >
                                <Dropdown
                                    label={"Select campaign"}
                                    options={options}
                                    styles={dropdownStyles}
                                    onChange={(e, item) => this.setState({ followUpToCampaignID: item.key.toString() })}
                                    selectedKey={this.state.followUpToCampaignID}
                                />
                                <Dropdown
                                    label="Send to"
                                    options={[
                                        { key: 'clicked', text: 'Recipients, who clicked' },
                                        { key: 'opened', text: 'Recipients, who opened (or clicked)' },
                                        { key: 'notopenednotclicked', text: 'Recipients, who did not open or click' },
                                        { key: 'any', text: 'All recipients' },

                                    ]}
                                    styles={dropdownStyles}
                                    onChange={(e, item) => this.setState({ followUpToCriteria: item.key.toString() })}
                                    selectedKey={this.state.followUpToCriteria}

                                />

                            </div>
                            <div className="-button" >
                                <PrimaryButton
                                    onClick={() => this.props.onCreateFollowUp(followUpToCampaignID, followUpToCriteria)}
                                    style={{ width: "100%" }}
                                    disabled={!canSendFollowUpCampaign}>
                                    <span style={{ "fontWeight": 400 }}>Start follow-up campaign</span>
                                </PrimaryButton>
                                <ul className="-links">
                                    <div className="" style={{ marginTop: "1rem" }}>
                                        <li key={'more'}><i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i>
                                            <Link target="_blank" href="https://mm365.me/faq-followup">FAQ about follow-up campaigns</Link></li>
                                    </div>
                                </ul>
                            </div>
                        </React.Fragment>}
                </Wrapper>
            </>
        );
    }
}
